// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"8de22454","796":"ceae6997","4707":"e0959d8e","6254":"456a8810","6455":"70756e1c","8688":"5f09114e","9915":"64e0f89b","9962":"4ab4375d"}[chunkId] + ".chunk.css";
};